/* eslint-disable */
<template>
  <div class="p-6 max-w-7xl mx-auto bg-white rounded-lg shadow-md">
    <!-- Header with Logo -->
    <div class="flex justify-between items-center mb-6 pb-4 border-b-2 border-blue-700">
      <div>
        <h2 class="text-3xl font-bold text-blue-900 uppercase">Femina Cover</h2>
        <p class="text-gray-600 mt-1">Women's Health Rider Quote Calculator</p>
      </div>
      <div class="flex justify-end">
        <img :src="logo" alt="Logo" class="h-20 w-auto object-contain" />
      </div>
    </div>

    <!-- Premium Preview -->
    <div v-if="previewPremium > 0" class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded-r-lg">
      <div class="flex justify-between items-center">
        <div>
          <h3 class="font-semibold text-blue-900">Estimated Premium</h3>
          <p class="text-sm text-gray-600">For the current selection</p>
        </div>
        <div class="text-right">
          <p class="text-xl font-bold text-green-600">{{ formatAmount(previewPremium) }}</p>
          <p class="text-xs text-gray-500">per year</p>
        </div>
      </div>
    </div>

    <form @submit.prevent="addEntry" class="mb-8 p-6 bg-gray-50 rounded-lg shadow-md border-t-4 border-blue-700">
      <h3 class="text-xl font-semibold text-blue-900 mb-4">Add Member Details</h3>
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <!-- Member Name -->
        <div>
          <label for="memberName" class="block text-sm font-semibold text-blue-900 mb-1">Member Name</label>
          <input v-model="form.memberName" id="memberName" type="text" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" required />
        </div>

        <!-- DOB -->
        <div>
          <label for="dob" class="block text-sm font-semibold text-blue-900 mb-1">Date of Birth</label>
          <input v-model="form.dob" id="dob" type="date" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition" required :max="maxDate" />
        </div>

        <!-- Femina Plus Benefit -->
        <div class="sm:col-span-2">
          <label for="feminaPlusBenefit" class="block text-sm font-semibold text-blue-900 mb-1">
            Femina Plus Benefit
            <span v-if="form.feminaPlusBenefit" class="text-xs bg-pink-100 text-pink-800 px-2 py-1 rounded ml-2">
              +{{ formatAmount(previewPremium) }}
            </span>
          </label>
          <select v-model="form.feminaPlusBenefit" id="feminaPlusBenefit" class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition">
            <option v-for="benefit in feminaPlusBenefits" :key="benefit" :value="benefit">{{ benefit }}</option>
          </select>
        </div>

        <!-- Submit Button -->
        <div class="sm:col-span-2">
          <button type="submit" class="w-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
            <span v-if="previewPremium > 0">
              Add Member - {{ formatAmount(previewPremium) }}
            </span>
            <span v-else>
              Add Entry
            </span>
          </button>
        </div>
      </div>
    </form>
  </div>

  <!---begin of pdf report -->
  <div class="p-6 max-w-7xl mx-auto bg-white rounded-lg shadow-md mt-6">
    <div class="flex justify-between items-center mb-6 pb-4 border-b-2 border-blue-700">
      <div>
        <h3 class="text-lg font-semibold text-blue-900">Client Details</h3>
        <p class="text-xs text-gray-500">Shown on the generated quote PDF</p>
      </div>
      <img :src="logo" alt="Logo" class="h-16 w-auto object-contain" />
    </div>
    <div class="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200 grid grid-cols-2 md:grid-cols-4 gap-4">
      <div>
        <p class="text-xs font-semibold text-blue-900 uppercase">Name</p>
        <p class="text-sm text-gray-700">{{ this.clientDetails.name || '-' }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold text-blue-900 uppercase">Email</p>
        <p class="text-sm text-gray-700">{{ this.clientDetails.email || '-' }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold text-blue-900 uppercase">Mobile</p>
        <p class="text-sm text-gray-700">{{ this.clientDetails.phone || '-' }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold text-blue-900 uppercase">Intermediary</p>
        <p class="text-sm text-gray-700">{{ this.clientDetails.intermediary || '-' }}</p>
      </div>
    </div>

    <!-- Results Table -->
    <div v-if="entries.length" class="mt-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-bold text-blue-900">Members List ({{ entries.length }} member{{ entries.length !== 1 ? 's' : '' }})</h3>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full border-collapse border border-blue-300 hidden md:table">
          <thead>
            <tr class="bg-blue-700 text-white">
              <th class="border border-blue-300 p-2">Member Name</th>
              <th class="border border-blue-300 p-2">DOB</th>
              <th class="border border-blue-300 p-2">Age</th>
              <th class="border border-blue-300 p-2">Gender</th>
              <th class="border border-blue-300 p-2">Femina Cover</th>
              <th class="border border-blue-300 p-2">Femina Premium</th>
              <th class="border border-blue-300 p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in entries" :key="entry.entry_id" class="hover:bg-blue-50 transition">
              <td class="border border-blue-300 p-2">{{ entry.memberName }}</td>
              <td class="border border-blue-300 p-2">{{ entry.dob }}</td>
              <td class="border border-blue-300 p-2 text-center">{{ entry.age }}</td>
              <td class="border border-blue-300 p-2 text-center">{{ entry.gender }}</td>
              <td class="border border-blue-300 p-2">{{ entry.feminaPlusBenefit }}</td>
              <td class="border border-blue-300 p-2 bg-gray-50">{{ formatAmount(calculateFeminaPlusPremium(entry.feminaPlusBenefit)) }}</td>
              <td class="border border-blue-300 p-2 text-center">
                <button
                  @click="deleteEntry(entry.entry_id)"
                  class="text-red-600 hover:text-red-800"
                  title="Delete Entry"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile Table -->
        <div class="md:hidden space-y-4">
          <div v-for="entry in entries" :key="entry.entry_id" class="border border-blue-200 p-4 rounded-lg shadow-sm">
            <div class="grid grid-cols-2 gap-2 text-sm">
              <div class="font-semibold text-blue-900">Member Name:</div>
              <div>{{ entry.memberName }}</div>
              <div class="font-semibold text-blue-900">DOB:</div>
              <div>{{ entry.dob }}</div>
              <div class="font-semibold text-blue-900">Age:</div>
              <div>{{ entry.age }}</div>
              <div class="font-semibold text-blue-900">Gender:</div>
              <div>{{ entry.gender }}</div>
              <div class="font-semibold text-blue-900">Femina Plus:</div>
              <div>{{ entry.feminaPlusBenefit }} ({{ formatAmount(calculateFeminaPlusPremium(entry.feminaPlusBenefit)) }})</div>
            </div>
            <div class="mt-4 flex justify-end">
              <button
                @click="deleteEntry(entry.entry_id)"
                class="text-red-600 hover:text-red-800 font-semibold text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Premium Summary Cards -->
      <div class="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg shadow-lg p-4 text-white">
          <p class="text-sm opacity-90">Basic Premium</p>
          <p class="text-2xl font-bold">{{ formatAmount(basicPremium) }}</p>
        </div>
        <div class="bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-lg shadow-lg p-4 text-white">
          <p class="text-sm opacity-90">Levies @ 0.45%</p>
          <p class="text-2xl font-bold">{{ formatAmount(levies) }}</p>
        </div>
        <div class="bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg shadow-lg p-4 text-white">
          <p class="text-sm opacity-90">Stamp Duty</p>
          <p class="text-2xl font-bold">{{ formatAmount(stampDuty) }}</p>
        </div>
        <div class="bg-gradient-to-r from-red-600 to-red-700 rounded-lg shadow-lg p-4 text-white md:col-span-3">
          <p class="text-sm opacity-90">Total Premium</p>
          <p class="text-3xl font-bold">{{ formatAmount(totalPremium) }}</p>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else class="text-center py-12">
      <div class="text-6xl mb-4">📋</div>
      <h3 class="text-xl font-semibold text-gray-600 mb-2">No Members Added Yet</h3>
      <p class="text-gray-500">Please add a member above to generate an insurance quote</p>
    </div>
  </div>
  <!--End of pdf report -->

  <div v-if="entries.length" class="p-6 max-w-7xl mx-auto bg-white rounded-lg shadow-md mt-6 flex justify-center space-x-4">
    <button @click="clearEntries" type="button" class="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
      Clear Entries
    </button>
    <button @click="printQuote" type="button" class="bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
      Generate Quote
    </button>
    <button @click="backHome" type="button" class="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 transform hover:scale-105">
      Back Home
    </button>
  </div>

</template>

<script>
import benefits from '@/data/perperson.json';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  drawHeaderBanner, drawClientInfo, drawSectionBar, ensureSpace,
  drawBulletList, addPageNumber, drawFooterBlock, drawPremiumSummaryBoxes,
  generateReference, THEME,
} from '@/utils/pdfLayout';

export default {
  data() {
    return {
      form: {
        memberName: '',
        dob: '',
        gender: 'F',
        feminaPlusBenefit: 'Silver'
      },
      entries: JSON.parse(localStorage.getItem('entries')) || [],
      benefits,
      logo: require('@/assets/logo.png'), // Importing the logo
      clientDetails: JSON.parse(localStorage.getItem('clientDetails')) ||
      {
        name: this.$route.query.name || '',
        email: this.$route.query.email || '',
        phone: this.$route.query.phone || '',
        intermediary: this.$route.query.intermediary || ''
       }
    };
  },
  computed: {
    feminaPlusBenefits() {
      return ['Silver', 'Gold', 'Platinum'];
    },

    previewPremium() {
      return this.form.feminaPlusBenefit ? this.calculateFeminaPlusPremium(this.form.feminaPlusBenefit) || 0 : 0;
    },

    basicPremium() {
      return this.entries.reduce((total, entry) => {
        // Calculate premium only if the benefit is not null
        let feminaPlusPremium = entry.feminaPlusBenefit ? this.calculateFeminaPlusPremium(entry.feminaPlusBenefit) : 0;

        // Sum up all the premiums
        return total + feminaPlusPremium;
      }, 0);
    },

    levies() {
      return this.basicPremium * 0.0045;
    },

    stampDuty() {
      return 40;
    },
    totalPremium() {
      return this.basicPremium + this.levies + this.stampDuty;
    },
    minDate() {
      const today = new Date();
      const year = today.getFullYear() - 60;
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    maxDate() {
      const today = new Date();
      const year = today.getFullYear() - 18;
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const day = ('0' + today.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    }
  },
  methods: {
    formatAmount(amount) {
        if (amount === null || amount === undefined) {
            return '-';
        }
        return amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },

    calculateTotalPremium(entry) {
        // Initialize total to 0
        let total = 0;

        // Add each premium if it exists, or skip if not
        if (entry.feminaPlusBenefit) {
            total += this.calculateFeminaPlusPremium(entry.feminaPlusBenefit);
        }

        // Return the total premium
        return total;
    },

    calculateFeminaPlusPremium(benefit) {
      return this.benefits['feminaPlus'][benefit] || null;
    },
    addEntry() {
      const age = this.calculateAge(this.form.dob);
      const entry_id = Date.now();
      const newEntry = { ...this.form, age, entry_id };

      this.entries.push(newEntry);
      localStorage.setItem('entries', JSON.stringify(this.entries));
      this.resetForm();
    },

    deleteEntry(id) {
      this.entries = this.entries.filter(entry => entry.entry_id !== id);
      localStorage.setItem('entries', JSON.stringify(this.entries));
    },

    resetForm() {
      this.form = {
        memberName: '',
        dob: '',
        gender: 'F',
        feminaPlusBenefit: null
      };
    },
    clearEntries() {
      this.entries = [];
      localStorage.removeItem('entries');
    },
    calculateAge(dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },

    printQuote() {
        const doc = new jsPDF('p', 'mm', 'a4');
        const margin = 14;
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const contentWidth = pageWidth - margin * 2;

        const currentDate = new Date();
        const timestamp = currentDate.toLocaleString();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const year = currentDate.getFullYear();
        const get_date = `${day}/${month}/${year}`;
        const reference = generateReference('FCQ');

        const pageFooterHook = (data) => {
          addPageNumber(doc, data.pageNumber, pageHeight, pageWidth, margin);
        };

        let y = drawHeaderBanner(doc, {
          title: 'FEMINA PLUS HEALTH INSURANCE',
          logo: this.logo,
          pageWidth, margin,
          timestampLabel: `APA Femina Plus quotation tool - ${timestamp}`,
        });
        y = drawClientInfo(doc, this.clientDetails, y, margin);

        // Member benefits table
        y = drawSectionBar(doc, 'MEMBER BENEFITS', y, margin, contentWidth);
        autoTable(doc, {
            startY: y,
            head: [['Member Name', 'DOB', 'Age', 'Gender', 'Femina Plus', 'Premium']],
            body: this.entries.map(entry => [
                entry.memberName,
                entry.dob,
                this.calculateAge(entry.dob),
                entry.gender,
                entry.feminaPlusBenefit || 'N/A',
                entry.feminaPlusBenefit ? this.formatAmount(this.calculateFeminaPlusPremium(entry.feminaPlusBenefit)) : 'N/A',
            ]),
            margin: { left: margin, right: margin },
            theme: 'grid',
            headStyles: { fillColor: THEME.navy, textColor: 255, fontSize: 8.5, halign: 'center', valign: 'middle' },
            bodyStyles: { fontSize: 8, valign: 'middle', halign: 'center' },
            columnStyles: { 0: { halign: 'left' } },
            didDrawPage: pageFooterHook
        });
        y = doc.previousAutoTable.finalY + 10;

        // Premium summary boxes
        const basicPremium = this.entries.reduce((sum, entry) => sum + this.calculateTotalPremium(entry), 0);
        const levies = (0.45 / 100) * basicPremium;
        const stampDuty = 40;
        const totalPremium = basicPremium + levies + stampDuty;

        y = ensureSpace(doc, y, 70, pageHeight, margin);
        y = drawSectionBar(doc, 'PREMIUM SUMMARY', y, margin, contentWidth);
        y = drawPremiumSummaryBoxes(doc, y, margin, contentWidth, {
          basicPremium,
          levies,
          stampDuty,
          totalDue: totalPremium,
          totalMembers: this.entries.length,
          totalFamilies: 1,
          formatCurrency: this.formatCurrency,
        });

        // Terms & Conditions
        y = ensureSpace(doc, y, 20, pageHeight, margin);
        y = drawSectionBar(doc, 'TERMS & CONDITIONS', y, margin, contentWidth, { fill: THEME.red, gap: 3 });

        y = ensureSpace(doc, y, 15, pageHeight, margin);
        y = drawSectionBar(doc, 'WAITING PERIODS', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = drawBulletList(doc, [
          '30 days for illness-related treatment',
          '30 days for COVID-19 related treatment',
          '90 days for surgical procedures excluding pre-existing conditions',
          '10 months for Pregnancy related conditions',
          '12 months for pre-existing, chronic, HIV/AIDS, and congenital related conditions whether newly diagnosed or existing',
          '12 months for Fibroid, Hernias, Adenoidectomy, tonsillectomy, and Haemorrhoids treatment',
          'Waiting period waived in accidental cases',
          'Any undeclared pre-existing conditions will remain excluded for the lifetime of the policy'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 4;

        y = ensureSpace(doc, y, 15, pageHeight, margin);
        y = drawSectionBar(doc, 'DOCUMENTATION REQUIRED', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = drawBulletList(doc, [
          'Duly filled APA medical application form',
          "KYC (ID, KRA PIN, spouse's ID, Birth certificate/notification for the children)",
          'Any applicant who is 60 years and above must submit a current medical report on application for review',
          'Cover will commence after proof of payment is received.'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 4;

        y = ensureSpace(doc, y, 15, pageHeight, margin);
        y = drawSectionBar(doc, 'PAYMENT OPTIONS', y, margin, contentWidth, { height: 6, fontSize: 9 });
        y = drawBulletList(doc, [
          'Bank transfer or Cheque deposits to APA medical bank account at NCBA Account No. 6447560039',
          'Insurance Premium Financing (IPF) – maximum of 4 instalments. IPF documents to be received on or before the renewal date of the policy period.',
          'Mpesa Paybill number 511600, Account: Name of the Principal member'
        ], margin + 2, y, contentWidth - 4, pageHeight, margin);
        y += 6;

        y = ensureSpace(doc, y, 10, pageHeight, margin);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);
        doc.text('NB: This quote is valid for only 90 days from the date of issue.', margin, y);
        y += 10;

        y = ensureSpace(doc, y, 20, pageHeight, margin);
        drawFooterBlock(doc, y, margin, pageWidth, get_date, reference, 'Femina Cover Quote');

        // Save the document
        doc.save('quote.pdf');
        this.saveReport();
    },

    // Helper function to format currency
    formatCurrency(value) {
        return new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES' }).format(value);
    },

   // this.clearEntries();

    backHome() {
      this.entries = [];
      localStorage.removeItem('entries');
      this.$router.push('/');
    },

    saveReport() {
      const report = {
        clientName: this.clientDetails.name,
        email: this.clientDetails.email,
        phone: this.clientDetails.phone,
        numberOfEntries: this.entries.length,
        totalPremium: this.totalPremium.toFixed(2),
      };
      // eslint-disable-next-line
      const reportJson = JSON.stringify(report);
      // Logic to save the reportJson to a file or server
    },


  }
};
</script>

<style scoped>
/* Add any additional styling here */
</style>
